var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2754 4.5C14.4751 4.50021 15.3748 5.4749 15.375 6.59961V7.2002H18C18.45 7.2002 18.75 7.5752 18.75 7.9502C18.7499 8.40009 18.3749 8.7002 18 8.7002H17.4746V17.4004C17.4744 18.6002 16.4999 19.5 15.375 19.5H8.7002C7.50033 19.5 6.59982 18.5252 6.59961 17.4004V8.7002H6C5.55008 8.7002 5.2501 8.32513 5.25 7.9502C5.25 7.5002 5.625 7.2002 6 7.2002H8.47461V6.59961C8.47482 5.3998 9.45032 4.5 10.5752 4.5H13.2754ZM8.02539 17.4004C8.02565 17.7003 8.32513 18 8.625 18H15.2998C15.5997 18 15.9002 17.7752 15.9004 17.4004V8.7002H8.02539V17.4004ZM10.6504 10.5674C11.1003 10.5675 11.4004 10.9425 11.4004 11.3174V15.3672C11.4004 15.8171 11.0253 16.1171 10.6504 16.1172C10.2754 16.1172 9.90039 15.8172 9.90039 15.3672V11.3174C9.90039 10.8674 10.2004 10.5674 10.6504 10.5674ZM13.3496 10.5674C13.7996 10.5674 14.0996 10.9424 14.0996 11.3174V15.3672C14.0996 15.8172 13.7246 16.1172 13.3496 16.1172C12.8997 16.1171 12.5996 15.8171 12.5996 15.3672V11.3174C12.5996 10.8675 12.8997 10.5675 13.3496 10.5674ZM10.6504 6C10.3505 6 10.05 6.22484 10.0498 6.59961V7.2002H13.9502V6.59961C13.9499 6.29974 13.6495 6 13.3496 6H10.6504Z",
    fill: "#424752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/TRASH.4bbd4b481817970a77ef1c41deb56195.svg";
export { ForwardRef as ReactComponent };